module.exports = __webpack_public_path__ + "static/img/guide2.fa320d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/guide2.png
// module id = NVjv
// module chunks = 1